/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        name: "AccessControlBadConfirmation",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        name: "AccessControlEnforcedDefaultAdminDelay",
        type: "error",
    },
    {
        inputs: [],
        name: "AccessControlEnforcedDefaultAdminRules",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
        ],
        name: "AccessControlInvalidDefaultAdmin",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "neededRole",
                type: "bytes32",
            },
        ],
        name: "AccessControlUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        inputs: [],
        name: "EnforcedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpectedPause",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedCall",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "InvalidRoleAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [],
        name: "ReentrancyGuardReentrantCall",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "bits",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "SafeCastOverflowedUintDowncast",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "functionName",
                type: "string",
            },
        ],
        name: "UnexpectedCall",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminDelayChangeCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "effectSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminDelayChangeScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "DefaultAdminTransferCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "acceptSchedule",
                type: "uint48",
            },
        ],
        name: "DefaultAdminTransferScheduled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "managementContract",
                type: "address",
            },
        ],
        name: "UnityInitialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MANAGEMENT_SMART_CONTRACT_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "acceptDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "beginDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "burn",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "burnFrom",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "cancelDefaultAdminTransfer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
        ],
        name: "changeDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "defaultAdminDelayIncreaseWait",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "defaultAdmin",
                type: "address",
            },
            {
                internalType: "address",
                name: "managementContract",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdmin",
        outputs: [
            {
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingDefaultAdminDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "newDelay",
                type: "uint48",
            },
            {
                internalType: "uint48",
                name: "schedule",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollbackDefaultAdminDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "unpause",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "0x60a0604052306080523480156200001557600080fd5b506200002062000026565b620000da565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a00805468010000000000000000900460ff1615620000775760405163f92ee8a960e01b815260040160405180910390fd5b80546001600160401b0390811614620000d75780546001600160401b0319166001600160401b0390811782556040519081527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b50565b60805161269e620001046000396000818161124f0152818161127801526113f4015261269e6000f3fe6080604052600436106102255760003560e01c8063634e93da11610123578063a1eda53c116100ab578063cefc14291161006f578063cefc14291461067d578063cf6eefb714610692578063d547741f146106cd578063d602b9fd146106ed578063dd62ed3e1461070257600080fd5b8063a1eda53c146105ce578063a217fddf14610602578063a9059cbb14610617578063ad3cb1cc14610637578063cc8463c81461066857600080fd5b80638456cb59116100f25780638456cb591461054257806384ef8ffc146105575780638da5cb5b1461058457806391d148541461059957806395d89b41146105b957600080fd5b8063634e93da1461049f578063649a5ec7146104bf57806370a08231146104df57806379cc67901461052257600080fd5b80632f2ff15d116101b157806342966c681161017557806342966c6814610412578063485cc955146104325780634f1ef2861461045257806352d1902d146104655780635c975abb1461047a57600080fd5b80632f2ff15d14610381578063313ce567146103a157806336568abe146103bd5780633f4ba83a146103dd57806340c10f19146103f257600080fd5b80630aa6220b116101f85780630aa6220b146102ca57806318160ddd146102e15780631c437ee61461031f57806323b872dd14610341578063248a9ca31461036157600080fd5b806301ffc9a71461022a578063022d63fb1461025f57806306fdde0314610288578063095ea7b3146102aa575b600080fd5b34801561023657600080fd5b5061024a610245366004612115565b610722565b60405190151581526020015b60405180910390f35b34801561026b57600080fd5b50620697805b60405165ffffffffffff9091168152602001610256565b34801561029457600080fd5b5061029d610733565b6040516102569190612163565b3480156102b657600080fd5b5061024a6102c53660046121b2565b6107f6565b3480156102d657600080fd5b506102df61080e565b005b3480156102ed57600080fd5b507f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace02545b604051908152602001610256565b34801561032b57600080fd5b506103116000805160206125e983398151915281565b34801561034d57600080fd5b5061024a61035c3660046121dc565b610824565b34801561036d57600080fd5b5061031161037c366004612218565b61084a565b34801561038d57600080fd5b506102df61039c366004612231565b61086c565b3480156103ad57600080fd5b5060405160128152602001610256565b3480156103c957600080fd5b506102df6103d8366004612231565b610898565b3480156103e957600080fd5b506102df610961565b3480156103fe57600080fd5b506102df61040d3660046121b2565b610974565b34801561041e57600080fd5b506102df61042d366004612218565b610996565b34801561043e57600080fd5b506102df61044d36600461225d565b6109b8565b6102df61046036600461229d565b610bc2565b34801561047157600080fd5b50610311610bdd565b34801561048657600080fd5b506000805160206126298339815191525460ff1661024a565b3480156104ab57600080fd5b506102df6104ba36600461235f565b610bfa565b3480156104cb57600080fd5b506102df6104da36600461237a565b610c0e565b3480156104eb57600080fd5b506103116104fa36600461235f565b6001600160a01b03166000908152600080516020612589833981519152602052604090205490565b34801561052e57600080fd5b506102df61053d3660046121b2565b610c22565b34801561054e57600080fd5b506102df610c6e565b34801561056357600080fd5b5061056c610c81565b6040516001600160a01b039091168152602001610256565b34801561059057600080fd5b5061056c610c9d565b3480156105a557600080fd5b5061024a6105b4366004612231565b610cac565b3480156105c557600080fd5b5061029d610ce4565b3480156105da57600080fd5b506105e3610d23565b6040805165ffffffffffff938416815292909116602083015201610256565b34801561060e57600080fd5b50610311600081565b34801561062357600080fd5b5061024a6106323660046121b2565b610d96565b34801561064357600080fd5b5061029d604051806040016040528060058152602001640352e302e360dc1b81525081565b34801561067457600080fd5b50610271610da4565b34801561068957600080fd5b506102df610e22565b34801561069e57600080fd5b506106a7610e62565b604080516001600160a01b03909316835265ffffffffffff909116602083015201610256565b3480156106d957600080fd5b506102df6106e8366004612231565b610e90565b3480156106f957600080fd5b506102df610eb8565b34801561070e57600080fd5b5061031161071d36600461225d565b610ecb565b600061072d82610f15565b92915050565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace03805460609160008051602061258983398151915291610772906123a2565b80601f016020809104026020016040519081016040528092919081815260200182805461079e906123a2565b80156107eb5780601f106107c0576101008083540402835291602001916107eb565b820191906000526020600020905b8154815290600101906020018083116107ce57829003601f168201915b505050505091505090565b600033610804818585610f3a565b5060019392505050565b600061081981610f47565b610821610f51565b50565b600033610832858285610f5e565b61083d858585610fc5565b60019150505b9392505050565b6000908152600080516020612609833981519152602052604090206001015490565b8161088a57604051631fe1e13d60e11b815260040160405180910390fd5b6108948282611024565b5050565b6000805160206125c9833981519152821580156108cd57506108b8610c81565b6001600160a01b0316826001600160a01b0316145b15610952576000806108dd610e62565b90925090506001600160a01b0382161515806108ff575065ffffffffffff8116155b8061091257504265ffffffffffff821610155b1561093f576040516319ca5ebb60e01b815265ffffffffffff821660048201526024015b60405180910390fd5b5050805465ffffffffffff60a01b191681555b61095c8383611040565b505050565b600061096c81610f47565b610821611073565b6000805160206125e983398151915261098c81610f47565b61095c83836110d3565b6000805160206125e98339815191526109ae81610f47565b6108943383611109565b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a008054600160401b810460ff16159067ffffffffffffffff166000811580156109fe5750825b905060008267ffffffffffffffff166001148015610a1b5750303b155b905081158015610a29575080155b15610a475760405163f92ee8a960e01b815260040160405180910390fd5b845467ffffffffffffffff191660011785558315610a7157845460ff60401b1916600160401b1785555b6001600160a01b038616610ab757604051631c78150b60e11b81526001600160a01b03871660048201526000805160206125e98339815191526024820152604401610936565b610ac08761113f565b610b0260405180604001604052806005815260200164556e69747960d81b8152506040518060400160405280600381526020016255545960e81b815250611193565b610b0a6111a5565b610b126111ad565b610b1a6111bd565b610b326000805160206125e9833981519152876111cd565b50856001600160a01b0316876001600160a01b03167f023805474b45b6399d37f78d160592f13864770f7779e3a9950273810c68b15460405160405180910390a38315610bb957845460ff60401b19168555604051600181527fc7f505b2f371ae2175ee4913f4499e1f2633a7b5936321eed1cdaeb6115181d29060200160405180910390a15b50505050505050565b610bca611244565b610bd3826112e9565b610894828261132c565b6000610be76113e9565b506000805160206125a983398151915290565b6000610c0581610f47565b61089482611432565b6000610c1981610f47565b610894826114a5565b6000805160206125e9833981519152610c3a81610f47565b604051631c29f0dd60e21b81526020600482015260086024820152676275726e46726f6d60c01b6044820152606401610936565b6000610c7981610f47565b610821611515565b600080516020612649833981519152546001600160a01b031690565b6000610ca7610c81565b905090565b6000918252600080516020612609833981519152602090815260408084206001600160a01b0393909316845291905290205460ff1690565b7f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace04805460609160008051602061258983398151915291610772906123a2565b60008051602061264983398151915254600090600160d01b900465ffffffffffff166000805160206125c98339815191528115801590610d6b57504265ffffffffffff831610155b610d7757600080610d8d565b6001810154600160a01b900465ffffffffffff16825b92509250509091565b600033610804818585610fc5565b600080516020612649833981519152546000906000805160206125c983398151915290600160d01b900465ffffffffffff168015801590610dec57504265ffffffffffff8216105b610e06578154600160d01b900465ffffffffffff16610e1b565b6001820154600160a01b900465ffffffffffff165b9250505090565b6000610e2c610e62565b509050336001600160a01b03821614610e5a57604051636116401160e11b8152336004820152602401610936565b61082161155e565b6000805160206125c9833981519152546001600160a01b03811691600160a01b90910465ffffffffffff1690565b81610eae57604051631fe1e13d60e11b815260040160405180910390fd5b61089482826115fb565b6000610ec381610f47565b610821611617565b6001600160a01b0391821660009081527f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace016020908152604080832093909416825291909152205490565b60006001600160e01b031982166318a4c3c360e11b148061072d575061072d82611622565b61095c8383836001611657565b610821813361173f565b610f5c600080611778565b565b6000610f6a8484610ecb565b9050600019811015610fbf5781811015610fb057604051637dc7a0d960e11b81526001600160a01b03841660048201526024810182905260448101839052606401610936565b610fbf84848484036000611657565b50505050565b6001600160a01b038316610fef57604051634b637e8f60e11b815260006004820152602401610936565b6001600160a01b0382166110195760405163ec442f0560e01b815260006004820152602401610936565b61095c838383611853565b61102d8261084a565b61103681610f47565b610fbf83836111cd565b6001600160a01b03811633146110695760405163334bd91960e11b815260040160405180910390fd5b61095c8282611871565b61107b6118ca565b600080516020612629833981519152805460ff191681557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a150565b6001600160a01b0382166110fd5760405163ec442f0560e01b815260006004820152602401610936565b61089460008383611853565b6001600160a01b03821661113357604051634b637e8f60e11b815260006004820152602401610936565b61089482600083611853565b6111476118fa565b6001600160a01b03811661118057604051631c78150b60e11b81526001600160a01b038216600482015260006024820152604401610936565b61118b600082611943565b6108216111a5565b61119b6118fa565b6108948282611955565b610f5c6118fa565b6111b56118fa565b610f5c6119a6565b6111c56118fa565b610f5c6119c7565b60006000805160206125c9833981519152836112325760006111ed610c81565b6001600160a01b03161461121457604051631fe1e13d60e11b815260040160405180910390fd5b6001810180546001600160a01b0319166001600160a01b0385161790555b61123c84846119f5565b949350505050565b306001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614806112cb57507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166112bf6000805160206125a9833981519152546001600160a01b031690565b6001600160a01b031614155b15610f5c5760405163703e46dd60e11b815260040160405180910390fd5b60006112f481610f47565b6040516001600160a01b038316907f6b70829fcbe4891157f7a7496f9870927de3c8237adbe9cd39bae09b7382c40990600090a25050565b816001600160a01b03166352d1902d6040518163ffffffff1660e01b8152600401602060405180830381865afa925050508015611386575060408051601f3d908101601f19168201909252611383918101906123dc565b60015b6113ae57604051634c9c8ce360e01b81526001600160a01b0383166004820152602401610936565b6000805160206125a983398151915281146113df57604051632a87526960e21b815260048101829052602401610936565b61095c8383611aa1565b306001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614610f5c5760405163703e46dd60e11b815260040160405180910390fd5b600061143c610da4565b61144542611af7565b61144f919061240b565b905061145b8282611b2e565b60405165ffffffffffff821681526001600160a01b038316907f3377dc44241e779dd06afab5b788a35ca5f3b778836e2990bdb26a2a4b2e5ed69060200160405180910390a25050565b60006114b082611bbb565b6114b942611af7565b6114c3919061240b565b90506114cf8282611778565b6040805165ffffffffffff8085168252831660208201527ff1038c18cf84a56e432fdbfaf746924b7ea511dfe03a6506a0ceba4888788d9b910160405180910390a15050565b61151d611c03565b600080516020612629833981519152805460ff191660011781557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258336110b5565b6000805160206125c9833981519152600080611578610e62565b9150915061158d8165ffffffffffff16151590565b15806115a157504265ffffffffffff821610155b156115c9576040516319ca5ebb60e01b815265ffffffffffff82166004820152602401610936565b6115db60006115d6610c81565b611871565b506115e76000836111cd565b505081546001600160d01b03191690915550565b6116048261084a565b61160d81610f47565b610fbf8383611871565b610f5c600080611b2e565b60006001600160e01b03198216637965db0b60e01b148061072d57506301ffc9a760e01b6001600160e01b031983161461072d565b6000805160206125898339815191526001600160a01b0385166116905760405163e602df0560e01b815260006004820152602401610936565b6001600160a01b0384166116ba57604051634a1406b160e11b815260006004820152602401610936565b6001600160a01b0380861660009081526001830160209081526040808320938816835292905220839055811561173857836001600160a01b0316856001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b9258560405161172f91815260200190565b60405180910390a35b5050505050565b6117498282610cac565b6108945760405163e2517d3f60e01b81526001600160a01b038216600482015260248101839052604401610936565b600080516020612649833981519152546000805160206125c983398151915290600160d01b900465ffffffffffff168015611815574265ffffffffffff821610156117eb57600182015482546001600160d01b0316600160a01b90910465ffffffffffff16600160d01b02178255611815565b6040517f2b1fa2edafe6f7b9e97c1a9e0c3660e645beb2dcaa2d45bdbf9beaf5472e1ec590600090a15b5060010180546001600160a01b0316600160a01b65ffffffffffff948516026001600160d01b031617600160d01b9290931691909102919091179055565b61185b611c03565b611866838383611c34565b61095c838383611c47565b60006000805160206125c9833981519152831580156118a85750611893610c81565b6001600160a01b0316836001600160a01b0316145b156118c0576001810180546001600160a01b03191690555b61123c8484611d68565b6000805160206126298339815191525460ff16610f5c57604051638dfc202b60e01b815260040160405180910390fd5b7ff0c57e16840df040f15088dc2f81fe391c3923bec73e23a9662efc9c229c6a0054600160401b900460ff16610f5c57604051631afcd79f60e31b815260040160405180910390fd5b61194b6118fa565b6108948282611de4565b61195d6118fa565b6000805160206125898339815191527f52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace03611997848261247a565b5060048101610fbf838261247a565b6119ae6118fa565b600080516020612629833981519152805460ff19169055565b6119cf6118fa565b60017f9b779b17422d0df92223018b32b4d1fa46e071723d6817e2486d003becc55f0055565b6000600080516020612609833981519152611a108484610cac565b611a90576000848152602082815260408083206001600160a01b03871684529091529020805460ff19166001179055611a463390565b6001600160a01b0316836001600160a01b0316857f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a4600191505061072d565b600091505061072d565b5092915050565b611aaa82611e4d565b6040516001600160a01b038316907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a2805115611aef5761095c8282611eb2565b610894611f28565b600065ffffffffffff821115611b2a576040516306dfcc6560e41b81526030600482015260248101839052604401610936565b5090565b6000805160206125c98339815191526000611b47610e62565b835465ffffffffffff8616600160a01b026001600160d01b03199091166001600160a01b038816171784559150611b8790508165ffffffffffff16151590565b15610fbf576040517f8886ebfc4259abdbc16601dd8fb5678e54878f47b3c34836cfc51154a960510990600090a150505050565b600080611bc6610da4565b90508065ffffffffffff168365ffffffffffff1611611bee57611be9838261253a565b610843565b61084365ffffffffffff841662069780611f47565b6000805160206126298339815191525460ff1615610f5c5760405163d93c066560e01b815260040160405180910390fd5b611c3c611c03565b61095c838383611f57565b6000826001600160a01b03163b118015611c745750611c746000805160206125e983398151915283610cac565b1561095c5760405163abb381cb60e01b81526001600160a01b038481166004830152831660248201819052604482018390529063abb381cb90606401600060405180830381600087803b158015611cca57600080fd5b505af1925050508015611cdb575060015b61095c573d808015611d09576040519150601f19603f3d011682016040523d82523d6000602084013e611d0e565b606091505b508051600003611d605760405162461bcd60e51b815260206004820152601c60248201527f5554593a20555459526563656976657220686f6f6b206661696c6564000000006044820152606401610936565b805181602001fd5b6000600080516020612609833981519152611d838484610cac565b15611a90576000848152602082815260408083206001600160a01b0387168085529252808320805460ff1916905551339287917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a4600191505061072d565b611dec6118fa565b6000805160206125c98339815191526001600160a01b038216611e2557604051636116401160e11b815260006004820152602401610936565b80546001600160d01b0316600160d01b65ffffffffffff851602178155610fbf6000836111cd565b806001600160a01b03163b600003611e8357604051634c9c8ce360e01b81526001600160a01b0382166004820152602401610936565b6000805160206125a983398151915280546001600160a01b0319166001600160a01b0392909216919091179055565b6060600080846001600160a01b031684604051611ecf9190612559565b600060405180830381855af49150503d8060008114611f0a576040519150601f19603f3d011682016040523d82523d6000602084013e611f0f565b606091505b5091509150611f1f858383612095565b95945050505050565b3415610f5c5760405163b398979f60e01b815260040160405180910390fd5b6000828218828410028218610843565b6000805160206125898339815191526001600160a01b038416611f935781816002016000828254611f889190612575565b909155506120059050565b6001600160a01b03841660009081526020829052604090205482811015611fe65760405163391434e360e21b81526001600160a01b03861660048201526024810182905260448101849052606401610936565b6001600160a01b03851660009081526020839052604090209083900390555b6001600160a01b038316612023576002810180548390039055612042565b6001600160a01b03831660009081526020829052604090208054830190555b826001600160a01b0316846001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef8460405161208791815260200190565b60405180910390a350505050565b6060826120a557611be9826120ec565b81511580156120bc57506001600160a01b0384163b155b156120e557604051639996b31560e01b81526001600160a01b0385166004820152602401610936565b5080610843565b8051156120fc5780518082602001fd5b60405163d6bda27560e01b815260040160405180910390fd5b60006020828403121561212757600080fd5b81356001600160e01b03198116811461084357600080fd5b60005b8381101561215a578181015183820152602001612142565b50506000910152565b602081526000825180602084015261218281604085016020870161213f565b601f01601f19169190910160400192915050565b80356001600160a01b03811681146121ad57600080fd5b919050565b600080604083850312156121c557600080fd5b6121ce83612196565b946020939093013593505050565b6000806000606084860312156121f157600080fd5b6121fa84612196565b925061220860208501612196565b9150604084013590509250925092565b60006020828403121561222a57600080fd5b5035919050565b6000806040838503121561224457600080fd5b8235915061225460208401612196565b90509250929050565b6000806040838503121561227057600080fd5b61227983612196565b915061225460208401612196565b634e487b7160e01b600052604160045260246000fd5b600080604083850312156122b057600080fd5b6122b983612196565b9150602083013567ffffffffffffffff808211156122d657600080fd5b818501915085601f8301126122ea57600080fd5b8135818111156122fc576122fc612287565b604051601f8201601f19908116603f0116810190838211818310171561232457612324612287565b8160405282815288602084870101111561233d57600080fd5b8260208601602083013760006020848301015280955050505050509250929050565b60006020828403121561237157600080fd5b61084382612196565b60006020828403121561238c57600080fd5b813565ffffffffffff8116811461084357600080fd5b600181811c908216806123b657607f821691505b6020821081036123d657634e487b7160e01b600052602260045260246000fd5b50919050565b6000602082840312156123ee57600080fd5b5051919050565b634e487b7160e01b600052601160045260246000fd5b65ffffffffffff818116838216019080821115611a9a57611a9a6123f5565b601f82111561095c576000816000526020600020601f850160051c810160208610156124535750805b601f850160051c820191505b818110156124725782815560010161245f565b505050505050565b815167ffffffffffffffff81111561249457612494612287565b6124a8816124a284546123a2565b8461242a565b602080601f8311600181146124dd57600084156124c55750858301515b600019600386901b1c1916600185901b178555612472565b600085815260208120601f198616915b8281101561250c578886015182559484019460019091019084016124ed565b508582101561252a5787850151600019600388901b60f8161c191681555b5050505050600190811b01905550565b65ffffffffffff828116828216039080821115611a9a57611a9a6123f5565b6000825161256b81846020870161213f565b9190910192915050565b8082018082111561072d5761072d6123f556fe52c63247e1f47db19d5ce0460030c497f067ca4cebf71ba98eeadabe20bace00360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbceef3dac4538c82c8ace4063ab0acd2d15cdb5883aa1dff7c2673abb3d86984004eb447511d198029427679f4aa0c3d8d61aef654b7406640c44d074e101c9cdf02dd7bc7dec4dceedda775e58dd541e08a116c6c53815c0bd028192f7b626800cd5ed15c6e187e77e9aee88184c21f4f2182ab5827cb3b7e07fbedcd63f03300eef3dac4538c82c8ace4063ab0acd2d15cdb5883aa1dff7c2673abb3d8698401a264697066735822122081ceea29715617cde218f92f5129f1dd3b8820d6eaaacf65b7104660819516ce64736f6c63430008180033";
const isSuperArgs = (xs) => xs.length > 1;
export class Unity__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
Unity__factory.bytecode = _bytecode;
Unity__factory.abi = _abi;
//# sourceMappingURL=Unity__factory.js.map